// Shared formatters for the Overview metrics surface (CTV-759).
//
// These were module-local in MetricsSection and already duplicated in
// MetricsChart; the per-station breakdown table would have been a third
// copy. Cents in, display string out — the Overview renders exact cents
// throughout so a publisher can reconcile against receipt figures.

/** Two-decimal currency from a cents figure. */
export const formatCurrencyExact = (cents: number): string =>
  (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatImpressions = (n: number): string => n.toLocaleString('en-US');

export const formatPercent = (fraction: number): string =>
  fraction.toLocaleString('en-US', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
